import React from 'react';

import { WrapperExtraImage } from '../styled';

interface IProps {
  alt: string;
  src: string;
}

const DialogExtraImage = ({ alt, src }: IProps) => (
  <WrapperExtraImage>
    <img src={src} alt={alt} />
  </WrapperExtraImage>
);

export default DialogExtraImage;
